import { Input } from '@chakra-ui/react';
import Encoding from 'encoding-japanese';
import React from 'react';

export const BanInputType = {
  None: 1,
  FullWidth: 2
};

interface CheckInfoString {
  Length: number;
  BanInputType: number;
  Value: string;
}

interface props {
  CheckInfo: CheckInfoString;
  inputValue: string | undefined;
  setValue: React.Dispatch<React.SetStateAction<string | undefined>>;
  PhohibitionCharaCheck: boolean;
  PasswordFlg?: boolean;
}

const Cp932Array = [33120, 33121, 33148, 33169, 33170, 33226, 33116];

// Encoding.convertで取得したsjisの配列から10進数の文字コードを取得
const GetShiftJisCharacterCode = (sjis: number[]) => {
  const prefix = '0x';
  let charaCode = '';
  charaCode = charaCode.concat(prefix);
  for (let i = 0; i < sjis.length; i++) {
    charaCode = charaCode.concat(sjis[i].toString(16));
  }

  // forで作成した16進数の文字コードをNumberでキャストし、10進数に変え返す
  return Number(charaCode);
};
const CharacterConvertToShiftJisCode = (character: string) => {
  // messageから一文字ずつunicodeへ変換
  const unicode = Encoding.stringToCode(character);
  //unicodeをutf-8へ変換
  const utf = Encoding.convert(unicode, {
    to: 'UTF8',
    from: 'UNICODE'
  });
  // utf-8をsjisへ変換
  const sjis = Encoding.convert(utf, {
    to: 'SJIS',
    from: 'UTF8'
  });
  // 上で取得したsjisの配列から10進数の文字コードを取得
  const charCode = GetShiftJisCharacterCode(sjis);
  return charCode;
};

const PhohibitionCharacterCheckOnChange = (inputData: string) => {
  let phohibitionAddInputData = inputData;

  for (let i = 0; i < inputData.length; i++) {
    const charCode = CharacterConvertToShiftJisCode(inputData[i]);
    // NEC特殊文字があるか
    if (34624 <= charCode && charCode <= 34719) {
      phohibitionAddInputData = phohibitionAddInputData.replace(
        phohibitionAddInputData.substring(i, i + 1),
        '?'
      );
    }
    // IBM拡張文字があるか
    else if (64064 <= charCode && charCode <= 64591) {
      phohibitionAddInputData = phohibitionAddInputData.replace(
        phohibitionAddInputData.substring(i, i + 1),
        '?'
      );
    }
    // NEC選定IBM拡張文字があるか
    else if (60736 <= charCode && charCode <= 61183) {
      phohibitionAddInputData = phohibitionAddInputData.replace(
        phohibitionAddInputData.substring(i, i + 1),
        '?'
      );
    }
    //cp932特殊文字？があるか（～、||など）
    else if (Cp932Array.includes(charCode)) {
      phohibitionAddInputData = phohibitionAddInputData.replace(
        phohibitionAddInputData.substring(i, i + 1),
        '?'
      );
    }
  }
  return phohibitionAddInputData;
};

export const CustomStringInput: React.FC<props> = (props) => {
  const {
    CheckInfo,
    inputValue,
    setValue,
    PhohibitionCharaCheck,
    PasswordFlg = false
  } = props;

  const StringInputCheck = (inputData: string) => {
    if (inputData.length <= CheckInfo.Length) {
      if (PhohibitionCharaCheck) {
        setValue(PhohibitionCharacterCheckOnChange(inputData));
        return;
      }

      if (CheckInfo.BanInputType === BanInputType.FullWidth) {
        if (
          inputData.includes(' ') ||
          (inputData !== '' && !inputData.match(/^[\x20-\x7e]+$/))
        ) {
          return;
        }
      }
      setValue(inputData);
      return;
    }
  };

  return (
    <>
      <Input
        mt={2}
        w='95%'
        type={PasswordFlg ? 'password' : 'text'}
        placeholder={CheckInfo.Value}
        value={inputValue}
        onChange={(e) => StringInputCheck(e.target.value)}
      ></Input>
    </>
  );
};
